import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginScreen from "@/screens/LoginScreen";
import ReportScreen from "@/screens/ReportScreen";
import SubstituteScreen from "@/screens/SubstituteScreen";
import EmptyScreen from "@/screens/EmptyScreen";
import DmrScreen from "@/screens/DmrScreen";

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            path: '/login',
            component: LoginScreen,
            title: 'Belépés',
            navigationBar: true,
            icon: 'mdi-account-key',
            meta: {header: 'min'}
        },
        {
            path: '/report',
            component: ReportScreen,
            title: 'Online jegyzőkönyv',
            navigationBar: true,
            icon: 'mdi-soccer',
            meta: {header: 'report'}
        },
        {
            path: '/substitute',
            component: SubstituteScreen,
            title: 'Csere adminisztráció',
            navigationBar: true,
            icon: 'mdi-swap-horizontal-bold',
            meta: {header: 'substitute'}
        },
        {
            path: '/dmr',
            component: DmrScreen,
            title: 'Versenyellenőr (DMR)',
            navigationBar: true,
            icon: 'mdi-swap-horizontal-bold',
            meta: {header: 'dmr'}
        },
        {
            path: '/game-not-started',
            component: EmptyScreen,
            title: 'Nincs mérkőzés',
            navigationBar: true,
            icon: 'exit-run',
            meta: {
                header: 'logout',
                icon: 'mdi-exit-run',
                title: 'A mérkőzés még nem kezdődött el, kérem próbálja meg később!',
            }
        },
        {
            path: '/logout',
            component: EmptyScreen,
            title: 'Sikeres kijelentkezés',
            navigationBar: true,
            icon: 'exit-run',
            meta: {
                header: 'logout',
                icon: 'mdi-exit-run',
                title: 'Sikeres kijelentkezés',
            }
        },
        {
            path: '/no-permission',
            component: EmptyScreen,
            title: 'Nincs jogosultsága',
            navigationBar: true,
            icon: 'mdi-do-not-disturb',
            meta: {
                header: 'no-permission',
                icon: 'mdi-do-not-disturb',
                title: 'Nincs jogosultsága',
            }
        }
    ]
})
